import { ExecutionPanelMenuItem } from "@src/features/ai/components/WorkflowEditor/execution/panel/header/ExecutionPanelMenuItem";
import {
  CopyChatIdMenuItem,
  CopyTranscriptMenuItem,
} from "@src/features/ai/components/WorkflowEditor/execution/panel/header/ExecutionPanelMenuItems";
import { useDispatch } from "@src/store";
import { VivIdeasAction } from "@src/store/slices/experienceBuilder/ideas";

/**
 * Viv's chat menu: the panel built-ins Viv wants (it has no new-chat action),
 * plus the Idea Library entry — which is what keeps the library reachable once
 * the conversation has turns and the empty state's link is gone.
 */
export const VivMenuItems = () => {
  const dispatch = useDispatch();

  return (
    <>
      <CopyChatIdMenuItem />
      <CopyTranscriptMenuItem />
      <ExecutionPanelMenuItem
        onClick={() => void dispatch(VivIdeasAction.openLibrary())}
      >
        Browse ideas
      </ExecutionPanelMenuItem>
    </>
  );
};
